import axios from 'axios';
import {getCookie} from '@insticator/insticator-ui'; // iui-utils
import {url} from '../../../utils/urls';

const withCredentials = true;

const headers = {
  "Content-Type": "application/json",
  'Accept': 'application/json',
  'Authorization': `Bearer ${getCookie('pub_portal_user')}`
};


export const getModerationConfig = ({ siteId }) => axios.get(`${url.ccb.url}/v1/sites/${siteId}/moderations/configs`, { withCredentials });

export const updateModerationConfig = ({ moderationConfigId, data}) => axios.put(`${url.ccb.url}/v1/moderations/${moderationConfigId}/configs`, data, { headers, withCredentials });
